import { useDocumentStore } from '@/stores/useDocumentStore';
import { Loader2, CheckCircle2, AlertTriangle } from 'lucide-react';
import { Progress } from './progress';
import { potentialMatchNames, selectVerificationOutcome, verificationOutcomeLabel } from '@/domain/document-processing/utils/verification-outcome';

export function ProcessingIndicator() {
  const state = useDocumentStore();
  const outcome = selectVerificationOutcome(state);
  const { processingProgress = 0, processingErrors = [], totalFiles = 0, currentFileIndex = 0 } = state.documentMetadata;
  if (outcome === 'unknown' && !state.results.length && !state.consolidationResult) return null;
  const running = outcome === 'running';
  return (
    <section aria-label="Verification status" role="status" className="space-y-3 rounded-md border p-4">
      <div className="flex items-center gap-2 font-medium">
        {running ? <Loader2 aria-hidden="true" className="h-5 w-5 animate-spin motion-reduce:animate-none text-primary" />
          : outcome === 'complete' ? <CheckCircle2 aria-hidden="true" className="h-5 w-5 text-success" />
          : <AlertTriangle aria-hidden="true" className="h-5 w-5 text-warning" />}
        {verificationOutcomeLabel[outcome]}
      </div>
      {running ? <>
        {totalFiles > 0 && <p className="text-sm text-muted-foreground">Processing document {Math.min(currentFileIndex + 1, totalFiles)} of {totalFiles}</p>}
        <Progress value={processingProgress} aria-label="Verification progress" />
        <p className="text-xs text-muted-foreground">{Math.round(processingProgress)}%</p>
      </> : <p className="text-sm text-muted-foreground">
        {outcome === 'complete' ? (potentialMatchNames(state).length ? 'Results are ready. Review the potential matches below.' : 'Results are ready to inspect.')
          : outcome === 'unknown' ? 'This saved order has no recorded verification outcome. Inspect the available results.'
          : 'Available results are retained. Inspect the documents and unresolved findings.'}
      </p>}
      {processingErrors.length > 0 && <ul className="list-disc pl-5 text-sm text-destructive">{processingErrors.map((error, index) => <li key={index}>{error}</li>)}</ul>}
    </section>
  );
}
